import React  from 'react';
import { Container, Filler} from './ProgressBar.styles';

const ProgressBar = ({ width, color }) => {
    return (
        <Container>
            <Filler style={{width: `${width}%`, background: color}}>
            </Filler>
        </Container>
    );
}

ProgressBar.defaultProps = {
    color: "#FF2E2E"
}

export default ProgressBar;